/**
 * Fallback user-facing module display name (browser tab, page header, breadcrumbs).
 * Prefer `module_display_name` from `GET /global/config` when present.
 */
export const MODULE_DISPLAY_NAME = "AI Hub";

/** Resolve API `module_display_name` with the static fallback. */
export function resolveModuleDisplayName(
  moduleDisplayName?: string | null,
): string {
  const trimmed = moduleDisplayName?.trim();
  return trimmed ? trimmed : MODULE_DISPLAY_NAME;
}
